import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { IFiltersView, ISelectedFilter } from '../../../../../api/events.dao';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import DefaultButton from '../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import SaveConfigurationBody from '../../../../_events/_manage-event/shared/save-view-form/save-configuration-body';
import FilteredViewFormVM from './save-filtered-view-form.viewmodel';
import { cancelText } from '../../../../../constants/common-labels.constants';

const SaveFilteredViewPresentation = mobxReact.observer((props: { vm: FilteredViewFormVM }) => {
    const { vm } = props;

    return (
        <CommonModal
            title={
                <FormattedMessage
                    id='oe.eventTracker.saveFilteredView'
                    description='Modal header text'
                    defaultMessage='Save Filtered View'
                />
            }
            classNameBody='save-configuration__modal-body'
            isOpen={true}
            onRequestClose={vm.onClose}
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        disabled={vm.isSaving}
                        text={
                            <FormattedMessage
                                id='oe.common.save'
                                defaultMessage='Save'
                                description='Button text'
                            />
                        }
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.handleSaveView}
                    />
                    <DefaultCloseModalButton text={cancelText()} />
                </div>
            }
        >
            <SaveConfigurationBody
                label={<FormattedMessage
                    id='oe.eventTracker.filteredViewName'
                    defaultMessage='Filtered View Name'
                    description='Label text'
                />}
                nameValue={vm.viewName}
                handleChangeNameValue={vm.changeViewName}
                getNameError={() => vm.isSubmitted && vm.getViewNameError()}
                columns={vm.selectedFilters
                    .find(el => el.filterName === 'Columns')
                    ?.filterValues
                    .map(el => el.label)
                }
                selectedFilters={vm.selectedFilters.filter(el => el.filterName !== 'Columns')}
            />
        </CommonModal>
    );
});

interface IProps {
    onClose: () => void;
    onSave: (view: IFiltersView) => Promise<void>;
    selectedFilters: ISelectedFilter[];
}

const SaveFilteredViewContainer = withViewModel(
    SaveFilteredViewPresentation, (props: IProps) => {
        const { onSave, onClose, selectedFilters } = props;
        const vm = new FilteredViewFormVM(onSave, onClose, selectedFilters);

        return vm;
    }
);

export { SaveFilteredViewContainer as SaveFilteredViewModal, SaveFilteredViewPresentation };
